import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, TimePicker, Card, message, Row, Col } from "antd";
import { useHttp } from "../../../utils/DataHendler";

export const AddLocationForm = () => {
  const [loading, setLoading] = useState(false);
  const { postData } = useHttp();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const payload = {
        name: values.name,
        latitude: values.latitude,
        longitude: values.longitude,
        start_time: values.start_time.format("HH:mm:ss"),
        end_time: values.end_time.format("HH:mm:ss"),
        description: values.description,
      };
      await postData("/location", payload, true);
      message.success("Location added successfully!");
      navigate("/user/location-list");
    } catch (err) {
      message.error("Failed to add location.");
    }
    setLoading(false);
  };

  return (
    <Row justify="center">
      <Col xs={24} sm={20} md={16} lg={12}>
        <Card
          title="Add New Location"
          bordered
          style={{ marginTop: 32, borderRadius: 8 }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Form.Item
              label="Location Name"
              name="name"
              rules={[
                { required: true, message: "Please input location name" },
              ]}
            >
              <Input placeholder="e.g. Depan Gudang Garam" />
            </Form.Item>
            <Form.Item
              label="Latitude"
              name="latitude"
              rules={[{ required: true, message: "Please input latitude" }]}
            >
              <Input placeholder="e.g. -7" />
            </Form.Item>
            <Form.Item
              label="Longitude"
              name="longitude"
              rules={[{ required: true, message: "Please input longitude" }]}
            >
              <Input placeholder="e.g. 162." />
            </Form.Item>
            <Form.Item
              label="Start Time"
              name="start_time"
              rules={[{ required: true, message: "Please select start time" }]}
            >
              <TimePicker format="HH:mm:ss" style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label="End Time"
              name="end_time"
              rules={[{ required: true, message: "Please select end time" }]}
            >
              <TimePicker format="HH:mm:ss" style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: "Please input description" }]}
            >
              <Input.TextArea rows={3} placeholder="e.g. Depan Gudang Garam" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{ width: "100%" }}
              >
                Add Location
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                style={{ width: "100%" }}
                onClick={() => navigate("/user/location-list")}
              >
                Cancel
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default AddLocationForm;
